export function isPointInsideClientRect(point: { x: number; y: number }, rect: DOMRect) {
    return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
}

export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        // eslint-disable-next-line deprecation/deprecation
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (!success) console.log('[Arise] copyToClipboard: execCommand failed');
        return success;
    }
}
